import { render } from "./TasksApp.vue?vue&type=template&id=53bb4d68"
import script from "./TasksApp.vue?vue&type=script&lang=js"
export * from "./TasksApp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__